import { countTypeEnum, OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { ChildClubbedLots } from "./lot-clubbing-items.entity";
// import { Address } from "./address.entity";

@Entity('master_clubbed_lots')
export class MatserClubbedLots {

  @PrimaryGeneratedColumn("increment",{name:'lot_id'})
  lotId:number;
  @Column("int",{
    nullable:true,
    name:"sale_order_id"
    })
    saleOrderId:number;
    @Column("int",{
        nullable:true,
        name:"so_item_id"
        })
        soItemId:number;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"main_lot_number"
    })
    mainLot:string;
    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'operation'
    })
    operation: OperationTypeEnum;
    @Column('int', {
        nullable: true,
        default: 0,
        name: "plant_id"
    })
    plantId: number;
    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'sub_plant_id'
    })
    subPlantId: number;
    @Column({
        type: 'int',
        nullable: false,
        name: 'prod_inv_id'
    })
    productionInventoryId: number;
    
    @Column("varchar",{
        nullable:false,
        length:255,
        name:"purpose"
        })
    purpose:string;
    @Column("varchar",{
        nullable:false,
        length:255,
        name:"remarks"
        })
    remarks:string;

    @Column('int',{
        name:'count',
        nullable:false
      })
      count : number

    @Column('decimal',{
        name:'qty_avail',
        precision:10,scale:3,
        unsigned:true
    })
    qtyAvailable : number

    @Column('decimal',{
        name:'qty_aft_club',
        precision:10,scale:3,
        unsigned:true
    })
    qtyAfterClub : number

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })

  versionFlag: number;

  @Column('int',{
    name:'year',
    nullable:false
  })
  year : number


  @Column('decimal',{
      name:'clubbed_qty',
      precision:10,scale:3,
      unsigned:true
  })
  clubbedQuantity : number

  @Column("varchar",{
      nullable:true,
      name:"new_lot_number"
      })
  newLotNumber:string;

  @Column('enum',{
    nullable:true,
    name:'count_type',
    enum:countTypeEnum
  })
  countType : countTypeEnum

  @Column("int",{
    nullable:true,
    name:"new_product"
    })
  newProduct:number;

  @Column('varchar',{
    name:'new_count',
    length : 20
  })
  newCount : string

 
  @OneToMany(type => ChildClubbedLots, childLotItem => childLotItem.masterLotInfo, { cascade: true })
  childLotInfo: ChildClubbedLots[];
  
 


}
